import {getLoggedIn} from "@awe-web/shared/lib";
import {MyBmwRentDashboard} from "../../../routing/routes.js";

export const initialize = () => async (dispatch, getState) => {
  if (getLoggedIn(getState())) {
    return MyBmwRentDashboard.path();
  }
};
